import { render, staticRenderFns } from "./ThreadsToolbarMessageDialogItemList.vue?vue&type=template&id=00441c1e&scoped=true"
import script from "./ThreadsToolbarMessageDialogItemList.vue?vue&type=script&lang=ts"
export * from "./ThreadsToolbarMessageDialogItemList.vue?vue&type=script&lang=ts"
import style0 from "./ThreadsToolbarMessageDialogItemList.vue?vue&type=style&index=0&id=00441c1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00441c1e",
  null
  
)

export default component.exports